import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

import * as AuthToken from './utils/auth/Auth-token';

const rootElement = document.getElementById('root')
const root = ReactDOM.createRoot(rootElement)

const renderApp = () => {
    root.render(
        <App />
    )

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister();
}

const runApp = () => {
    const idToken = AuthToken.getToken()
    if (idToken) {
        renderApp()
    } else {
        AuthToken.removeToken()
        renderApp()
    }
}

runApp();